export default {"src":"/_next/static/media/logo-text.4041e558.svg","height":60,"width":760,"blurWidth":0,"blurHeight":0};